import { Toggle, toggleAutoInit } from './components/tiny-ui-toggle.js';
import { articleSharing } from './components/article-sharing.js';
import { dialogModal } from './components/dialog-modal.js';
import { PostsCatDropdown } from './components/post-cat-dropdown.js';
import { memberNav } from './components/member-nav.js';
import { myAccountDropdown } from './components/myaccount-dropdown.js';

window.addEventListener('DOMContentLoaded', function() {
  // Seach and mobile menu
  const searchToggleElement = document.querySelector('.search-toggle');
  // const mobileNavElement = document.querySelector('.menu-toggle');
  const siteHeaderElement = document.querySelector('.site-header');

  if(searchToggleElement) {
    const searchToggle = Toggle({ selector: searchToggleElement, animateHeight: false, closeOnEscape: true, closeAuto: true, closeAutoScope: 'click' });
  };
	const mobileNavToggle = Toggle({ selector: '.menu-toggle', animateHeight: false, bodyClass: 'has-menu-open', closeOnEscape: true });

  // Sub menu
  const headerBreakpoint = 1300;
  let headerSize = 0;
  let headerState = 'desktop';

  const header = function(headerState) {
    const primaryNavMenuToggles = document.querySelectorAll('.sub-menu-toggle');
    let toggleOptions = {};

    if (headerState === 'desktop') {
      // toggleOptions = { closeAutoWrapper: '.site-header', animateHeight: false };
      toggleOptions = { closeAuto: true, closeAutoWrapper: '.site-header', animateHeight: false };
      if (searchToggleElement) searchToggleElement.removeAttribute("disabled");
    }
    else {
      toggleOptions = {};
      if (searchToggleElement) searchToggleElement.setAttribute("disabled", "");
    }

    for (const item of primaryNavMenuToggles) {
      Toggle({ selector: item, ...toggleOptions });
    };
  }

  header(headerState);

  // Basic addin to focus inside the mobile menu
  function mobile_a11y_tabbing(){
    // Focus in the mobile menu on tab
    if (window.innerWidth < headerBreakpoint) {
      const mobile_menu_toggle = document.getElementById("js-menu-toggle");
      mobile_menu_toggle.addEventListener("keydown", function(event){
        if (event.key === 'Enter'){

          const mobile_menu = document.getElementById('menu-main-1');
          var mobile_menu_focusableEls = mobile_menu.querySelectorAll('a[href]:not([disabled])');
          var mobile_menu_firstFocusableEl = mobile_menu_focusableEls[0];  
              setTimeout(() => {
                mobile_menu_firstFocusableEl.focus();
              }, 500); // has a default time value of 0
        }
      });
    }
  }
  mobile_a11y_tabbing();

  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      const contentBoxSize = entry.contentBoxSize[0];
      headerSize = contentBoxSize.inlineSize;
    }

    let headerStateOld = headerState;
    headerState = (headerSize >= headerBreakpoint) ? 'desktop' : 'mobile';

    if (headerStateOld !== headerState) {
      header(headerState);
    }
  });

  if (siteHeaderElement) resizeObserver.observe(siteHeaderElement);

	// START: Hide Header on on scroll down
	var didScroll;
	var lastScrollTop = 0;
	var delta = 115;

  window.onscroll = () => {
    didScroll = true;
  }

	setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 250);

	function hasScrolled() {
		var st = window.scrollY;

    if (st >= 5) {
      siteHeaderElement.classList.add('header-scrolled');
    } else {
      siteHeaderElement.classList.remove('header-scrolled');
    }
		
		// Make sure they scroll more than delta
		if(Math.abs(lastScrollTop - st) <= delta)
			return;
		
		// If they scrolled down and are past the navbar, add class .nav-up.
		// This is necessary so you never see what is "behind" the navbar.
		if (st > lastScrollTop && parseInt( st ) > 0 ) {
			// Scroll Down
      siteHeaderElement.classList.remove('nav-down');
      siteHeaderElement.classList.add('nav-up');
		} else {
			// Scroll Up
			if(st + window.innerHeight < document.body.scrollHeight) {
        siteHeaderElement.classList.remove('nav-up');
        siteHeaderElement.classList.add('nav-down');
			}
		}
		
		lastScrollTop = st;
	}
	// END: Hide Header on on scroll down


  toggleAutoInit();

  articleSharing();

	dialogModal();

  PostsCatDropdown();

  memberNav();

  myAccountDropdown();

});
